var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_4930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.58341C9.65866 4.58341 9.37533 4.30008 9.37533 3.95841V2.29175C9.37533 1.95008 9.65866 1.66675 10.0003 1.66675C10.342 1.66675 10.6253 1.95008 10.6253 2.29175V3.95841C10.6253 4.30008 10.342 4.58341 10.0003 4.58341Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 8.75008C14.6587 8.75008 14.3753 8.46675 14.3753 8.12508V2.29175C14.3753 1.95008 14.6587 1.66675 15.0003 1.66675C15.342 1.66675 15.6253 1.95008 15.6253 2.29175V8.12508C15.6253 8.46675 15.342 8.75008 15.0003 8.75008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 8.75008C4.65866 8.75008 4.37533 8.46675 4.37533 8.12508V2.29175C4.37533 1.95008 4.65866 1.66675 5.00033 1.66675C5.34199 1.66675 5.62533 1.95008 5.62533 2.29175V8.12508C5.62533 8.46675 5.34199 8.75008 5.00033 8.75008Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0836 7.38342L12.1836 9.58342C12.3336 9.88342 12.7336 10.1834 13.067 10.2334L15.0586 10.5668C16.3336 10.7834 16.6336 11.7001 15.717 12.6168L14.167 14.1751C13.9086 14.4334 13.7586 14.9418 13.842 15.3084L14.2836 17.2334C14.6336 18.7501 13.8253 19.3418 12.4836 18.5501L10.617 17.4418C10.2753 17.2418 9.7253 17.2418 9.38364 17.4418L7.50864 18.5418C6.16697 19.3334 5.35864 18.7418 5.70864 17.2251L6.1503 15.3001C6.23364 14.9418 6.08364 14.4334 5.8253 14.1668L4.28364 12.6251C3.36697 11.7084 3.66697 10.7834 4.94197 10.5751L6.93364 10.2418C7.26697 10.1834 7.66697 9.89176 7.81697 9.59176L8.91697 7.39176C9.50864 6.19176 10.492 6.19176 11.0836 7.38342Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_4930)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/animation.d336257b92d2b17e93219020a79f5087.svg";
export { ForwardRef as ReactComponent };